var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Plus",

    getDefaultProps () {
        return {"width":"13px","height":"14px","viewBox":"0 0 13 14","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>+</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="new-ticket" transform="translate(-7.000000, -6.000000)" fill="currentColor">
      <g id="Group-3">
        <polygon id="+" points="12.628 13.476 7 13.476 7 11.992 12.628 11.992 12.628 6 14.14 6 14.14 11.992 19.768 11.992 19.768 13.476 14.14 13.476 14.14 19.496 12.628 19.496"/>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/plus.svg
 **/